import React, { useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencilAlt } from "@fortawesome/free-solid-svg-icons";
import { toast } from "react-toastify";

import ContactSaisie from "./ContactSaisie";

const ContactConfirmation = ({ onConfirm, formData, setFormData }) => {
    const [isEditing, setIsEditing] = useState(false);
    const [code, setCode] = useState("");
    const [generatedCode] = useState(Math.random().toString(36).substr(2, 6));

    const handleSubmit = (e) => {
        e.preventDefault();
        if (code === generatedCode) {
          onConfirm(); // Envoie l'email
        
        } else {
          toast.error("The code entered is incorrect !", {
            position: "top-right",
            autoClose: 3000,
            hideProgressBar: false,
            closeOnClick: true,
            pauseOnHover: true,
            draggable: true,
            progress: undefined,
            theme: "colored",
          });
    
          console.log("The code entered is incorrect ! "+code+" != "+generatedCode);
          // onConfirm(); // Envoie l'email
        }
      };

    const handleEdit = () => {
        setIsEditing(true);
    };

    const handleEditSubmit = (updatedData) => {
        setFormData(updatedData); // Update the state with the new data
        setIsEditing(false); // Exit editing mode
    };
    

    return isEditing ? (
        <ContactSaisie 
          onSubmit={handleEditSubmit} // Ensure `onSubmit` is passed here
          field={formData} // Pre-filled data
        />
      ) : (
        <div className="container-fluid py-5 bg-dark-purple">
          <div className="bg-dark container py-5 rounded">
            <h2 className="text-center">Confirm your information</h2>
            <ul className="list-group">
              <li className="list-group-item d-flex justify-content-between align-items-center">
                <div>Name: <strong>{formData.user_name}</strong></div>
                <button
                  className="btn btn-link p-2 bg-jaune"
                  onClick={() => handleEdit("user_name")}
                  title="Edit"
                >
                  <FontAwesomeIcon icon={faPencilAlt} />
                </button>
              </li>
              <li className="list-group-item d-flex justify-content-between align-items-center">
                <div>Email: <strong>{formData.user_email}</strong></div>
                <button
                  className="btn btn-link p-2 bg-jaune"
                  onClick={() => handleEdit("user_email")}
                  title="Edit"
                >
                  <FontAwesomeIcon icon={faPencilAlt} />
                </button>
              </li>
              <li className="list-group-item d-flex justify-content-between align-items-center">
                <div>Message: <strong>{formData.message}</strong></div>
                <button
                  className="btn btn-link p-2 bg-jaune"
                  onClick={() => handleEdit("message")}
                  title="Edit"
                >
                  <FontAwesomeIcon icon={faPencilAlt} />
                </button>
              </li>
            </ul>
            <form onSubmit={handleSubmit} className="mt-4">
              <div className="mb-3">
                <label htmlFor="code" className="form-label">
                  Copy this code: <strong>{generatedCode}</strong>
                </label>
                <input
                  type="text"
                  className="form-control"
                  id="code"
                  value={code}
                  onChange={(e) => setCode(e.target.value)}
                  placeholder="Enter the code here"
                  required
                />
              </div>
              <button type="submit" className="btn btn-submit btn-dark w-100">
                Confirm sending your email
              </button>
            </form>
          </div>
        </div>
      );
      
};

export default ContactConfirmation;
